import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["BackToTop"] */ "/vercel/path0/src/components/back-to-top.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/src/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavbarWrapper"] */ "/vercel/path0/src/components/navbar-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpellingProvider"] */ "/vercel/path0/src/components/providers/spelling-provider.tsx");
